<template>
  <div class="box">
    <div class="teachersetup_wrap">
      <el-dialog title="提示" :modal-append-to-body="false" :visible.sync="dialogVisible" width="30%">
        <div>
          <label>章节状态</label>
          <el-select v-model="value1" class="select1" placeholder="请选择">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div>
          <label>答案状态</label>
          <el-select v-model="value2" class="select1" placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="setOneData">确 定</el-button>
        </span>
      </el-dialog>
      <div class="setup_top_box">
        <div style="font-size:16px;">设置课程</div>
        <div>
          <el-button @click="setData(1)">开放章节</el-button>
          <el-button @click="setData(2)">锁定章节</el-button>
          <el-button @click="setData(3)">显示答案</el-button>
          <el-button @click="setData(4)">隐藏答案</el-button>
        </div>
      </div>
      <section>
        <ul>
          <li>
            <div class="checkbox">
              <!-- <el-checkbox v-model="checked"></el-checkbox> -->
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
              ></el-checkbox>
            </div>
            <div >章节</div>
            <div>章节状态</div>
            <div>答案状态</div>
            <div>操作</div>
          </li>
          <el-tree
            v-if="listState"
            :data="list"
            :props="defaultProps"
            node-key="id"
            show-checkbox
            :highlight-current="true"
            @check-change="handleCheckChange"
            ref="tree"
          >
            <span class="span-ellipsis" slot-scope="{ node, data }">
              <div class="div_null"></div>
              <span class="tree_name">{{node.label}}</span>
              <span class="tree_issuedStatus">
                <span v-if="data.issuedStatus==0">开放</span>
                <span v-if="data.issuedStatus==1">锁定</span>
              </span>
              <span class="tree_answerStatus">
                <span v-if="data.answerStatus==1">显示</span>
                <span v-if="data.answerStatus==0">隐藏</span>
              </span>
              <span class="tree_setup">
                <button class="btn_null" @click.stop="clickSet(data,node)">设置</button>
              </span>
            </span>
          </el-tree>
        </ul>
        <div v-if="!listState" class="null_box">
          <img src="../../../../../../static/images/wujieguo.png" />
          <p>暂无数据</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import * as api from "../../../../../api/teacherSetUpApi";
// import tipsDialog from '../../../dialog/tipsDialog/index'
export default {
  data() {
    return {
      list: [],
      listState: false,
      checked: false,
      classId: this.$route.query.classId,
      courseId: this.$route.query.id,
      checkAll: false,
      isIndeterminate: false,
      dataList: [], //提交的数组
      dialogVisible: false,
      defaultProps: {
        children: "children",
        label: "catalogName"
      },
      options1: [
        {
          value: 0,
          label: "开放"
        },
        {
          value: 1,
          label: "锁定"
        }
      ],
      options2: [
        {
          value: 1,
          label: "显示"
        },
        {
          value: 0,
          label: "隐藏"
        }
      ],
      value1: 0,
      value2: 0,
      oneData: [],
      num: 0 //单选框计数
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.getSetUpList();
    });
    this;
  },
  methods: {
    getSetUpList() {
      let data2 = {
        classId: this.classId,
        courseId: this.courseId
      };

      api.getSetUpList(data2).then(res => {
        console.log(res);
        let list = res.data;
        if (res.data.length > 0) {
          this.list = list;

          this.listState = true;
        } else {
          console.log("暂无数据");
        }
      });
      this.dataList = [];
      this.checkAll = false;
    },
    handleCheckAllChange(val) {
      if (this.checkAll) {
        //全选

        this.$refs.tree.setCheckedNodes(this.list);
        console.log(111);
      } else {
        //取消选中
        this.$refs.tree.setCheckedNodes([]);
        console.log(222);
      }
    },
    handleCheckChange() {
      let res = this.$refs.tree.getCheckedNodes();
      let arr = [];
      res.forEach(item => {
        let obj = {
          answerStatus: item.answerStatus,
          catalogId: item.catalogId,
          classId: this.classId,
          courseId: this.courseId,
          issuedStatus: item.issuedStatus
        };
        arr.push(obj);
      });
      console.log(arr);
      this.dataList = arr;
    },
    setData(e) {
      console.log(e);
      let data = this.dataList;

      if (data.length == 0) {
           this.$message({
          showClose: true,
          message: '请选择修改数据',
          type: 'warning'
        });
        return;
      }
      if (e === 1) {
        //开放发布
        this.$tipsDialog(
          "提示",
          "确定开放发布吗？",
          "",
          "el-icon-warning",
          "rgb(255, 178, 60)"
        )
          .then(() => {
            console.log("confirm");
            this.dataList.map(v => {
              return (v.issuedStatus = 0);
            });

            api.setData(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "修改成功!"
                });
              } else {
                this.$message.error("修改失败");
              }
              console.log(res);
              this.getSetUpList();
            });
          })
          .catch(() => {
            console.log("cancel");
          });
      } else if (e === 2) {
        //隐藏发布
        this.$tipsDialog(
          "提示",
          "确定锁定发布吗？",
          "",
          "el-icon-warning",
          "rgb(255, 178, 60)"
        )
          .then(() => {
            console.log("confirm");
            this.dataList.map(v => {
              return (v.issuedStatus = 1);
            });

            api.setData(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "修改成功!"
                });
              } else {
                this.$message.error("修改失败");
              }
              console.log(res);
              this.getSetUpList();
            });
          })
          .catch(() => {
            console.log("cancel");
          });
      } else if (e === 3) {
        //开放答案
        this.$tipsDialog(
          "提示",
          "确定显示答案吗？",
          "",
          "el-icon-warning",
          "rgb(255, 178, 60)"
        )
          .then(() => {
            console.log("confirm");
            this.dataList.map(v => {
              return (v.answerStatus = 1);
            });

            api.setData(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "修改成功!"
                });
              } else {
                this.$message.error("修改失败");
              }
              console.log(res);
              this.getSetUpList();
            });
          })
          .catch(() => {
            console.log("cancel");
          });
      } else if (e === 4) {
        //隐藏答案
        this.$tipsDialog(
          "提示",
          "确定隐藏答案吗？",
          "",
          "el-icon-warning",
          "rgb(255, 178, 60)"
        )
          .then(() => {
            console.log("confirm");
            this.dataList.map(v => {
              return (v.answerStatus = 0);
            });

            api.setData(data).then(res => {
              console.log(res);
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "修改成功!"
                });
              } else {
                this.$message.error("修改失败");
              }
              this.getSetUpList();
            });
          })
          .catch(() => {
            console.log("cancel");
          });
      }
    },
    clickSet(v) {
      //单独设置的时候 因为数据有
      this.dialogVisible = true;
      this.value1 = v.issuedStatus;
      this.value2 = v.answerStatus;
      let list3 = [];
      let obj = {
        answerStatus: v.answerStatus,
        catalogId: v.catalogId,
        classId: this.classId,
        courseId: this.courseId,
        issuedStatus: v.issuedStatus
      };
      list3.push(obj);
      v.children.forEach(vv => {
        let obj = {
          answerStatus: vv.answerStatus,
          catalogId: vv.catalogId,
          classId: this.classId,
          courseId: this.courseId,
          issuedStatus: vv.issuedStatus
        };
        list3.push(obj);
        vv.children.forEach(vvv => {
          let obj = {
            answerStatus: vvv.answerStatus,
            catalogId: vvv.catalogId,
            classId: this.classId,
            courseId: this.courseId,
            issuedStatus: vvv.issuedStatus
          };
          list3.push(obj);
        });
      });
      this.oneData = list3;
      this.dataList = list3;
    },
    setOneData() {
      this.$tipsDialog(
        "提示",
        "确定修改吗？",
        "",
        "el-icon-warning",
        "rgb(255, 178, 60)"
      )
        .then(() => {
          console.log("confirm");
          console.log(this.value1);
          console.log(this.value2);

          this.oneData.map(v => {
            v.issuedStatus = this.value1;
            return (v.answerStatus = this.value2);
          });
          let data = this.oneData;
          api.setData(data).then(res => {
            console.log(res);
            this.getSetUpList();
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "修改成功!"
              });
            } else {
              this.$message.error("修改失败");
            }
          });
        })
        .catch(() => {
          console.log("cancel");
        });
      this.dialogVisible = false;
    }
  }
  //   setData
};
</script>

<style lang="scss" scoped>
.box {
  padding: 16px 16px 0 16px;
  background-color: rgba(244, 244, 244, 1);
  font-size: 12px;
  height: 100%;
}
.teachersetup_wrap {
  padding: 0 24px;

  height: calc(100% - 32px);
  background: white;
  overflow: hidden;
  .setup_top_box {
    display: flex;
    justify-content: space-between;
    justify-items: center;
    height: 52px;
    margin-bottom: 14px;
    line-height: 52px;
    border-bottom: 1px solid rgba(83, 151, 247, 1);
    button {
      width: 88px;
      height: 30px;
      // line-height: 30px;
      margin-top: 10px;
      border: 1px solid rgba(83, 151, 247, 1);
      opacity: 1;
      border-radius: 4px;
      font-size: 12px;
      line-height: 0;
      color: rgba(83, 151, 247, 1);    
    }
    
   
  }
  section {
    // height: 592px;
    height: calc(100% - 65px);

    overflow-y: auto;

    ul {
      li {
        display: flex;
        justify-content: space-between;
        line-height: 47px;

        border: 1px solid rgba(226, 226, 226, 1);
        div {
          flex: 1;

          /deep/ .el-checkbox {
            display: block;
            margin: 0 auto;
            span {
              display: block;
              margin: 0 auto;
              margin-top: 14px;
            }
            // margin-top: 14px;
          }
          /deep/ button {
            width: 56px;
            height: 24px;
            border: 1px solid rgba(228, 232, 241, 1);
            opacity: 1;
            border-radius: 12px;
            color: rgba(83, 151, 247, 1);
          }
        }

        div {
          text-align: center;
        }
        :nth-child(2) {
          min-width: 61%;
          text-align: left;
        }
      }
      li:nth-of-type(1) {
        height: 40px;
        font-size: 14px;
        background: rgba(83, 151, 247, 0.1);
        border-radius: 4px 4px 0px 0px;

        & > div {
          color: rgba(153, 153, 153, 1);
        }
      }
    }
    /deep/ .el-checkbox__inner {
      margin-left: 16px;
    }
    .span-ellipsis {
      width: 100%;
      display: flex;
      justify-content: space-between;

      span {
        flex: 1;
        display: inline-block;
        text-align: center;
      }
      .tree_name {
        flex: 6.1;
        text-align: left;
      }
    }
  }

  /deep/ .el-dialog__wrapper {
    .el-dialog__header {
      // width:100;
      padding: 0 !important;
      height: 48px;
      background: rgba(83, 151, 247, 1);

      opacity: 1;
      border-radius: 8px 8px 0px 0px;
    }

    .el-dialog {
      width: 480px !important;
      height: 278px;
      background: rgba(255, 255, 255, 1);
      opacity: 1;
      border-radius: 8px;
      margin-top: 30vh !important;
    }
    .el-dialog__body {
      width: 480px;
      & > div {
        display: flex;
        justify-content: center;
        //    align-content: center;
        align-items: center;
        label {
          margin-left: -20px;
          width: 58px;
          height: 19px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 19px;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
          //    margin-right:13px;
        }
        & > div {
          margin-left: 13px;
          width: 271px;
        }
      }
      & > div:nth-of-type(2) {
        margin-top: 20px;
      }
    }
    .el-dialog__footer {
      width: 480px;
      margin-top: -20px;
      padding-right: 0;
    }
    .el-dialog__title {
      //    margin-top: 20px;
      line-height: 50px;
      margin-left: 10px;
      color: white;
    }
    .el-dialog__headerbtn > i {
      color: white;
    }
  }

  .btn_null {
    border: none;
    background: none;
    margin-left: 20px;
    width: 56px;
    height: 24px;
    border: 1px solid #e4e8f1;
    opacity: 1;
    border-radius: 12px;
    color: #5397f7;
    font-size: 10px;
    background: white;
  }
  .null_ct {
    width: 100%;
    height: calc(100% - 40px);
    text-align: center;
    line-height: 50;
  }
  ::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
  /deep/ .el-tree-node__expand-icon {
    // display: none;
    position: absolute;
    left: 7%;
  }
  /deep/ .el-tree-node__content {
    height: 40px;
    line-height: 40px;
    padding-left: 0 !important;
  }

  /deep/ .el-checkbox__inner {
    margin-left: 50px !important;
    margin-right: 50px !important;
  }
  /deep/ .el-checkbox {
    .el-checkbox__inner {
      position: absolute;
      top: -10px;
      margin: 0;
      padding: 0;
    }
  }
  .checkbox {
    width: 100px;
   
    /deep/ .el-checkbox__inner {
      position: absolute;
      top: 0 !important;
      margin: 0;
      padding: 0;
    }
  }

  /deep/ .div_null {
    flex: 0.92;
    // .el-checkbox__inner{
    //    position: absolute;
    //    top: -12px  !important;
    //    margin: 0;
    //    padding: 0;
    // }
  }
  /deep/ .el-progress__text {
    font-size: 16px;
    font-weight: bold;
    line-height: 21px;
    color: rgba(83, 151, 247, 1) !important;
  }
  /deep/ .el-tree-node__children {
    width: 100%;
    .tree_name {
      text-indent: 16px;
      font-weight: 700;
      color: #666666;
    }
    .el-tree-node__children {
      .tree_name {
        text-indent: 32px;
        font-weight: 100;
        color: #666666;
      }
    }
  }
}
.null_box {
  padding-top: 100px;
  height: 100px;
  text-align: center;
  p {
    color: #999999;
  }
  img {
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/setUp/teacherSetUp.vue